import { CalendarAlertIcon } from './CalendarAlertIcon';

/**
 * author: Simran
 * id 38F5B0F1-FAC2-4389-9CE0-BDDEBEC868F4
 * name calendar-alert
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-alert.svg
 * tags
 * - Date / Time 
 * - Alert / Error 
 */
export const CalendarWarningIcon = CalendarAlertIcon;
export default CalendarWarningIcon